import { observer } from 'mobx-react';
import { PropsWithChildren, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { usePlpStore } from 'components/modules/plp/DataStore';
import { PlpTypes } from 'lib/apis/services/PlpListing';

interface Props extends PropsWithChildren {
  location: Partial<PlpTypes.DescribedLocationV2>[] | null
}

function FilterBoxMobxWrapper(props: Props) {
  const { children } = props;
  const { watch } = useFormContext<PlpTypes.FilterParams>();
  const { setData } = usePlpStore();
  const formData = watch();
  formData.location = JSON.parse(JSON.stringify(props.location));

  useEffect(() => {
    setData({ filterData: formData },"FilterBoxMobxWrapper", true);
  }, [formData]);

  return <>{children}</>;
}

export default observer(FilterBoxMobxWrapper);
